import { render, staticRenderFns } from "./AbaAtoPublicidade.vue?vue&type=template&id=6ca3a1cc"
import script from "./AbaAtoPublicidade.vue?vue&type=script&lang=ts"
export * from "./AbaAtoPublicidade.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports